import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const Banner = () => {
  return (
    <section
      id="home"
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
    >
      <div className="container mx-auto content-center text-center" >
        <div className="flex flex-col lg:flex-row gap-y-10 lg:items-center lg:gap-x-12 ">
          {/* Text */}
          <div className="flex-1 content-center font-secondary">
            <motion.h1
              variants={fadeIn("up", "0.3")}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[50px] lg:text-[75px] font-bold leading-[.8] uppercase"
            >
              Gabriel <span>Moretti</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", "0.4")}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white  mr-2">I'm</span>
              <TypeAnimation
                sequence={[
                  "Software Engineer",
                  2000,
                  "Full Stack Developer",
                  2000,
                  "Back end Engineer",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", "0.5")}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 lg:mx-0"
            >
              Lover of the technology universe and problem-solving. I enjoy
              constantly learning and seeing the impact of this on people's
              lives.
            </motion.p>
            <motion.div
              variants={fadeIn("up", "0.6")}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex justify-center items-center gap-x-6 lg:mx-0 mb-12"
            >
              <a
                href="/Gabriel_Moretti.pdf"
                download="Gabriel_Moretti.pdf"
              >
                <button className="btn btn-lg">Download Resume</button>
              </a>
              <a href="#" className="text-gradient btn-link">
                My portfolio
              </a>
            </motion.div>
            {/* Socials */}
            <motion.div
              variants={fadeIn("up", "0.7")}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex justify-center text-[20px] gap-x-6 mx-auto lg:mx-0"
            >
              <a
                href="https://github.com/GabrielMorettii"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/gabriel-morettii/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
